// Patterns that indicate errors from browser extensions or third-party scripts
const IGNORED_ERROR_PATTERNS = [
  // Chrome/Firefox extension errors
  /chrome-extension:\/\//,
  /moz-extension:\/\//,
  /safari-extension:\/\//,
  // Extension API calls
  /runtime\.sendMessage/,
  /Invalid call to runtime\.sendMessage/,
  // Java bridge errors (Android WebView / browser extensions)
  /Java object is gone/,
  /invoking postMessage/,
  // Common third-party/bot errors
  /ResizeObserver loop/,
  /Non-Error promise rejection captured with value: undefined/,
  // webkit messageHandlers (iOS)
  /webkit\.messageHandlers/,
  // Shopify browser extensions injecting scripts into non-Shopify sites
  /Shopify root is null/,
]

// URLs that are allowed - errors must originate from these domains
const ALLOWED_URLS = [
  /https?:\/\/((wholesale|www)\.)?doll\.com/,
  /https?:\/\/(www\.)?babesociety\.com/,
  /https?:\/\/d1cjavvf9wfh6p\.cloudfront\.net/,
]

function shouldIgnoreError(event) {
  const message = event.message || event.exception?.values?.[0]?.value || ''

  // Check if error message matches ignored patterns
  if (IGNORED_ERROR_PATTERNS.some(pattern => pattern.test(message))) {
    return true
  }

  // Check stack frames for extension URLs
  const frames = event.exception?.values?.[0]?.stacktrace?.frames || []
  for (const frame of frames) {
    const filename = frame.filename || ''
    if (/^(chrome|moz|safari)-extension:\/\//.test(filename)) {
      return true
    }
  }

  return false
}

function getSentryConfig() {
  const dsn = document.querySelector('meta[name="sentry-dsn"]')?.content
  const environment = document.querySelector('meta[name="sentry-environment"]')?.content
  const release = document.querySelector('meta[name="sentry-release"]')?.content

  if (!dsn) return null

  return {
    dsn,
    environment,
    release,
    allowUrls: ALLOWED_URLS,
    // Sentry 11 collects user IPs, cookies and request/response bodies unless told not to.
    // This is its documented v10 baseline, so checkout traffic sends what it did under v10.
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpHeaders: {
        request: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
        response: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
      },
      httpBodies: [],
      urlQueryParams: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
      genAI: { inputs: false, outputs: false },
      databaseQueryData: false,
      queues: false,
      graphQL: { document: false, variables: false },
    },
    beforeSend(event) {
      if (shouldIgnoreError(event)) {
        return null // Drop the event
      }
      return event
    },
  }
}

function getSentryUser() {
  const customerId = document.querySelector('meta[name="sentry-customer-id"]')?.content
  const adminId = document.querySelector('meta[name="sentry-admin-id"]')?.content

  if (!customerId && !adminId) return null

  const user = {}
  if (customerId) user.customer_id = customerId
  if (adminId) user.admin_id = adminId
  if (adminId) {
    user.id = `admin:${adminId}`
  } else if (customerId) {
    user.id = `customer:${customerId}`
  }

  return user
}

export { getSentryConfig, getSentryUser }
